import { Role, RoleTypeLabel } from "@/enum/RoleEnum";

export class InspectorListItem {
    /**
     * 점검 사용자 uuid
     * */
    readonly userUuid: string;
    /**
     * 점검 사용자 ID
     * */
    readonly userId: string;
    /**
     * 점검 사용자 이름
     * */
    readonly firstName: string;
    /**
     * 점검 사용자 소속
     * */
    readonly companyName: string;
    /**
     * 점검 사용자 휴대폰 번호
     * */
    readonly phone: string;
    /**
     * 점검 사용자 권한
     * */
    readonly role: string;
    /**
     * 가입 날짜
     * */
    readonly createdAt: string;

    get uri(): string {
        return `/inspectors/${this.userUuid}`;
    }

    get roleLabel(): string {
        return RoleTypeLabel[this.role as Role];
    }
}